<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("forma-pagamento") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t("vendas") }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'ven-forma-pagamento' })">{{ $t("formas-pagamento") }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $route.params.id && formapagamento.descricao ? $route.params.id + " - " + formapagamento.descricao : $t("novo") }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'ven-forma-pagamento' })"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="(!usuarioIntegracao && !isUpdate && permissao.create) || (!usuarioIntegracao && isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(3)"
                                ref="idErpInput"
                                v-model="formapagamento.idformapagtoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!formapagamento.idformapagtoerp"
                            />
                        </div>   
                        <div class="column is-7">
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="formapagamento.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!formapagamento.descricao"
                                uppercase
                                tooltipLabel="informacao-descricao-forma-pagamento"
                                tooltipSize="is-small"
                                title="descricao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :required="true"
                            />
                        </div>
                        
                        <div class="column is-3">
                            <vss-select
                                :id="generateId(2)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="formapagamento.id==null"
                                tooltipLabel="informacao-situacao-forma-pagamento"
                                tooltipSize="is-small"
                                title="situacao"
                                :tooltipMultilined="true"
                                :tooltipPosition="isMobile ? 'is-right' : 'is-left'"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormaPagtoService from "@/services/FormaPagtoService";
import FormaPagamentoValidation from "@/services/validations/vendas/FormaPagamentoValidation";
import Message from "@/models/Message";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    watch:{
        formapagamento:{
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit && !this.isSaving){
                    this.isChanged = true;
                }
            }
        }
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes("FORMAPAGTO"),
            service: new FormaPagtoService(this.$http, this.$router),
            validation: new FormaPagamentoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            formapagamento: {
                id: null,
                idformapagtoerp: null,
                descricao: null,
                situacao: null
            },
            isUpdate: false,
            situacoes: [{ label: "inativo", id: 0 }, { label: "ativo", id: 1 }],
            situacao: { label: "ativo", id: 1 },
            isMobile: false,
            isLoadingEdit: false,
        };
    },
    created() {
        this.isChanged = false;
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'vendas',
            'ven-forma-pagamento'
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'forma-pagamento' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    mounted() {
        this.resize();
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service.find(id)
                .then(value => {
                    this.formapagamento = value.content;
                    this.situacao = this.situacoes[this.formapagamento.situacao];
                })
                .catch(e => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(_ => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        sendIsChanged() {
            if (!this.isLoadingEdit && !this.isSaving) this.isChanged = true;
        },
        save() {
            this.isSaving = true;
            this.isLoading = true;
            this.isLoadingEdit = true;

            if (this.validation.validate(this.formapagamento, this.$refs)) {
                let formaPagamentoTemp = Object.assign({}, this.formapagamento);
                formaPagamentoTemp = this.mapTosave(formaPagamentoTemp);
                formaPagamentoTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service.save(formaPagamentoTemp)
                    .then(value => {
                        if (value.message == null) {
                            let msg = 'msg-save-forma-pagamento';
                            if (this.formapagamento.id != null) {
                                msg = 'msg-edit-forma-pagamento';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(new Message(
                                    'alert', 
                                    this.$t(message, { n: formaPagamentoTemp.idformapagtoerp }), 
                                    true, 
                                    false
                                ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.isLoading = false;
                this.isLoadingEdit = false;
                this.isSaving = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            this.isChanged = false;
            setTimeout(() => {
                this.$router.push({
                    name: 'ven-forma-pagamento',
                });
            }, 3 * 1000);
        },
        resize() {
            this.isMobile = window.innerWidth <= 768;
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>